.tooltip {
  background-color: var(--tuna-palette-grey-700);
  color: var(--tuna-palette-grey-50);
  border-radius: 4px;
  padding: 4px 8px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: 0.6875rem;
  font-weight: 500;
  max-width: 300px;
  word-wrap: break-word;
  z-index: var(--tuna-zIndex-tooltip);
}
